module.exports = __webpack_public_path__ + "img/mayun.ca69fea6.png";